import { useParams, Link } from 'react-router-dom';
import { useEffect, useState, useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'star-scandal');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const currentCategory = useMemo(
    () => categories.find((c) => c.slug === activeSlug) || categories[0],
    [activeSlug],
  );

  const filteredArticles = useMemo(
    () => articles.filter((a) => a.category === activeSlug),
    [activeSlug],
  );

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${currentCategory.name} - 黑料社区`,
          url: `https://heiliao.community/category/${activeSlug}`,
          description: currentCategory.description,
          isPartOf: {
            '@type': 'WebSite',
            name: '黑料社区',
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-24 md:pt-28 pb-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: currentCategory.name },
                ]}
              />
            </div>

            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                {currentCategory.name}
              </h1>
              <p className="text-sm text-foreground-500">{currentCategory.description}</p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-20 text-foreground-400">
                <i className="ri-inbox-line text-5xl mb-4"></i>
                <p className="text-lg">该分类暂无文章</p>
                <Link to="/" className="mt-4 text-primary-500 hover:text-primary-600 text-sm">
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}